import Button from "components/BaseWidgets/button";
import "./style.scss";
import { CircleTick } from "assets/icons";
import Tag from "components/BaseWidgets/tag";
import Divider from "components/BaseWidgets/divider";
import { priceFormatPrice } from "utils/formatHelper";
import { useProfileCompletion } from "hooks/api/useHome";

function PlanDetailsCard({
  data,
  btnText = "Explore our plans",
  isFree,
  onClick,
  isLoading,
}) {
  const {
    title,
    status,
    messageCount,
    infoMessage,
    oldPrice,
    currentPrice,
    planFeature,
    description,
  } = data;

  const { data: userData } = useProfileCompletion();

  return (
    <div className="plan-details-card">
      <div className="card-container">
        <div className="package-details">
          <div className="flex items-centre gap-3 flex-wrap">
            <span className={`plan-title ${!isFree && "premium-plan"}`}>
              {title}
            </span>
            {status && (
              <Tag readOnly className="purple-border-tag">
                <Divider circle height={5} width={5} bgColor="#FFFFFF" />
                {status}
              </Tag>
            )}
          </div>
          <p className="message-count">
            You {isFree && "only"} have
            <span>{messageCount}</span>
            {isFree ? "contact views left in your free plan" : "contact views left."}
          </p>
          <Tag className="purple-tag" onClick={onClick}>
            {infoMessage}
          </Tag>
        </div>
        {currentPrice && (
          <div className="package-price">
            <p className="old-price">{priceFormatPrice(oldPrice)}</p>
            <span className="offer-price">
              {priceFormatPrice(currentPrice)}
            </span>
          </div>
        )}
      </div>
      {description && (
        <p className="font-title-normal fw-500 leading-5">{description}</p>
      )}
      <ul className="list-container">
        {planFeature?.length > 0 ? (
          planFeature?.map((items, i) => (
            <li className="list-items" key={i}>
              <CircleTick />
              {items}
            </li>
          ))
        ) : (
          <li className="list-items">No special features available</li>
        )}
      </ul>
      <Button isLoading={isLoading} onClick={onClick} className="action-btn">
        {btnText}
      </Button>
    </div>
  );
}

export default PlanDetailsCard;
